import { type RootState } from '@/store';

export const isSnackbarOpen = ({ snackbar: { isSnackbarOpen } }: RootState) =>
  isSnackbarOpen;
export const snackbarType = ({ snackbar: { snackbarType } }: RootState) =>
  snackbarType;
export const snackbarMessage = ({ snackbar: { snackbarMessage } }: RootState) =>
  snackbarMessage;
